module.exports = __webpack_public_path__ + "static/img/search.bb871ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search.png
// module id = NzrC
// module chunks = 1